import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["ja", "en"],
    lng: "en",
    fallbackLng: "en",
    debug: false,
    detection: {
      order: ["path", "localStorage", "sessionStorage"],
      caches: ["localStorage"],
    },
    backend: {
      loadPath:
        "/locales/{{lng}}/translation.json?time=" + new Date().getTime(),
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
